export default [
    {
        path: 'encaminhamento',
        component: () => import(
            /* webpackChunkName: 'painel-senha-encaminhamento' */
            '@/views/painel-senha/encaminhamento/Index'
        ),
        redirect: 'encaminhamento/index',
        children: [
            {
                name: 'painel-senha-encaminhamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-encaminhamento-index' */
                    '@/views/painel-senha/encaminhamento/List.vue'
                ),
            },
            {
                name: 'painel-senha-encaminhamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-encaminhamento-create' */
                    '@/views/painel-senha/encaminhamento/Form.vue'
                ),
            },
            {
                name: 'painel-senha-encaminhamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-encaminhamento-edit' */
                    '@/views/painel-senha/encaminhamento/Form.vue'
                ),
            },
        ],
    },
]